/*Relation added 26.06*/

/*header-wrapper全体（ナビ行を含む）の高さを --header-wrapper-height として保持する。--header-heightはヘッダー上段のみでナビ行の高さを含まないため*/
(function () {
  var headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  var setHeaderWrapperHeight = function () {
    document.documentElement.style.setProperty(
      '--header-wrapper-height',
      headerWrapper.getBoundingClientRect().height + 'px'
    );
  };

  setHeaderWrapperHeight();
  new ResizeObserver(setHeaderWrapperHeight).observe(headerWrapper);
})();

/*Relation added 26.09 cont-faq・gmoptions__legal（dt/dd構成のFAQ）をcollapsible-content__contentと同様に開閉式にする*/
(function () {
  var setOpen = function (dt, dd, open) {
    if (open) {
      dd.style.height = dd.scrollHeight + 'px';
      dd.addEventListener('transitionend', function onEnd(event) {
        if (event.target !== dd || event.propertyName !== 'height') return;
        dd.style.height = 'auto';
        dd.removeEventListener('transitionend', onEnd);
      });
    } else {
      // 'auto'のままだと0pxへ遷移できないため、現在の実測高さへ一旦固定してからアニメーションさせる
      dd.style.height = dd.scrollHeight + 'px';
      dd.offsetHeight; // force reflow
      dd.style.height = '0px';
    }
  };

  var toggle = function (dt) {
    var dd = dt.nextElementSibling;
    if (!dd) return;
    var willOpen = dt.getAttribute('aria-expanded') !== 'true';
    dt.setAttribute('aria-expanded', String(willOpen));
    setOpen(dt, dd, willOpen);
  };

  document.querySelectorAll('.cont-faq__lst, .gmoptions__legal').forEach(function (list) {
    list.addEventListener('click', function (event) {
      var dt = event.target.closest('dt');
      if (!dt || !list.contains(dt)) return;
      toggle(dt);
    });

    list.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var dt = event.target.closest('dt');
      if (!dt || !list.contains(dt)) return;
      event.preventDefault();
      toggle(dt);
    });
  });
})();

